import io from "socket.io-client";

const token = localStorage.getItem("token");

// export const  hostname = io.connect("https://leon-gallery.com", {
// export const  hostname = io.connect("http://157.230.43.47:3005", { 
//  export const  hostname = io.connect("http://localhost:3005", {
  export const  hostname = io.connect("wss://socket.leon-gallery.com", { 
    transports: ["websocket"],
    withCredentials: true,
    reconnection: true, 
    reconnectionDelay: 30000 ,
    auth: { 
      token: token
    }
})

// export const  hostname = '';
 export const  GetURL = 'https://leon-gallery.com';
// export const  GetURL = 'http://157.230.43.47:8081'; 
// export const  GetURL = 'http://localhost:3000';
// export const  hostname = "";

 

